import React, { useState, useEffect } from "react";

import Heading from "../../Components/Heading?v=0.0.2";
import Description from "../../Components/Description?v=0.0.2";
import CustomLink from "../../Components/CustomLink?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import EmailTextField from "../../Components/EmailTextField?v=0.0.2";
import PasswordTextField from "../../Components/PasswordTextField?v=0.0.2";
import FeatureCardContainer from "../../Components/FeatureCardContainer?v=0.0.2";

import * as Constants from "../../Constants?v=0.0.2";
import * as SignUpController from "../../Controllers/myPlan/SignUpController?v=0.0.2";

import Plan_Budgets_Illustration from "../../Images/Plan_Budgets_Illustration.svg";
import What_If_Scenario_Illustration from "../../Images/What_If_Scenario_Illustration.svg";
import Predict_Cashflow_Illustration from "../../Images/Predict_Cashflow_Illustration.svg";

function SignUpMyPlan(props) {
  document.title = "myPlan | Sign Up";
  const environment = props.environment;
  const [checkAPI, setCheckAPI] = useState({
    dataStatus: { isSuccess: props.validEmail },
  });
  const [emailTFResultLabelFlag, setEmailTFResultLabelFlag] = useState(false);
  const [emailTFResultLabel, setEmailTFResultLabel] = useState("");
  const [email, setEmail] = useState(props.email);
  const [password, setPassword] = useState(props.password);
  const [validPassword, setValidPassword] = useState(props.validPassword);
  const [passwordLabel, setPasswordLabel] = useState("");
  const [showEmailLoader, setShowEmailLoader] = useState(false);
  const [googleLoader, setGoogleLoader] = useState(false);
  const [appleLoader, setAppleLoader] = useState(false);
  let validateBlur = false;

  useEffect(() => {
    window.AppleID.auth.init({
      clientId: "com.zetran.mybooksw",
      scope: "email name",
      redirectURI: environment.loginAppUrl + "/myPlan/signup",
      state: Constants.generateRandomString(30),
      usePopup: true,
    });
    if (props.responseInvalidMessage === "This user doesn't have a account !") {
      props.toast(
        "It seems like you are not registered with myPlan yet. Sign Up to continue."
      );
      props.clearResponseData();
      setShowEmailLoader(true);
      fetch(environment.myPlanLoginAppAPI + Constants.emailCheck, {
        method: "POST",
        body: JSON.stringify({
          User: {
            emailAddress: props.User.username,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.dataStatus.isSuccess) {
              setShowEmailLoader(false);
              setCheckAPI(result);
            } else {
              setShowEmailLoader(false);
              setCheckAPI(result);
              setEmailTFResultLabel(result.dataStatus.message);
              setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }

    async function checkIdToken() {
      var id_token =
        props.id_one_tap !== ""
          ? props.id_one_tap
          : window.location.hash.split(/&|=/)[3];
      if (id_token && id_token.length > 0) {
        setGoogleLoader(true);
        let result = await fetch(
          environment.myPlanLoginAppAPI + Constants.signInCheck,
          {
            method: "POST",
            body: JSON.stringify({
              User: {
                socialLogin: "true",
                socialLoginVia: "Google",
                id_token: id_token,
              },
            }),
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then(
            (result) => {
              return new Promise((resolve, reject) => {
                resolve(result);
              });
            },
            (error) => {
              return new Promise((resolve, reject) => {
                reject(error);
              });
            }
          );
        if (result.dataStatus && result.dataStatus.isSuccess) {
          if (
            Object.keys(result.payload).length &&
            result.payload.entry_method === "login"
          ) {
            setGoogleLoader(false);
            Constants.remove_hash_from_url();
            props.login(
              {
                emailAddress: result.payload.email,
                id_token: id_token,
              },
              Constants.myPlanOauthLogin
            );
          } else if (
            Object.keys(result.payload).length &&
            result.payload.entry_method === "signup"
          ) {
            setGoogleLoader(false);
            Constants.remove_hash_from_url();
            props.onDone({
              User: {
                username: result.payload.email,
                usernametype: "email",
                socialLogin: "true",
                socialLoginVia: "Google",
                id_token: id_token,
              },
            });
          }
        } else {
          Constants.remove_hash_from_url();
          setGoogleLoader(false);
        }
      }
    }
    checkIdToken();
  }, [environment, props, email]);

  const onEmailTFChange = (email) => {
    setEmailTFResultLabel("");
    setEmail((prevState) => {
      return email;
    });
    setCheckAPI((prevState) => {
      return { ...prevState, dataStatus: { isSuccess: false } };
    });
  };

  const onValidEmailHandler = (currentEmail) => {
    setEmail((prevState) => {
      return currentEmail;
    });
  };

  const changeEmailFlagHandler = (flag, currentEmail) => {
    setEmailTFResultLabelFlag(flag);
    setCheckAPI((prevState) => {
      return { ...prevState, dataStatus: { isSuccess: false } };
    });
    if (!flag) {
      setEmailTFResultLabel((prevState) => {
        return currentEmail !== "" ? "Please enter a valid email address." : "";
      });
    } else {
      setEmailTFResultLabel((prevState) => {
        return "";
      });
      setShowEmailLoader(true);
      fetch(environment.myPlanLoginAppAPI + Constants.emailCheck, {
        method: "POST",
        body: JSON.stringify({
          User: {
            emailAddress: email,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.dataStatus.isSuccess) {
              setShowEmailLoader(false);
              setCheckAPI(result);
              if (validateBlur) {
                SignUp();
                validateBlur = false;
              }
            } else {
              setShowEmailLoader(false);
              setCheckAPI(result);
              setEmailTFResultLabel(result.dataStatus.message);
              setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
              validateBlur = false;
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  const onValidNumberHandler = (currentNumber) => {
    onValidEmailHandler(currentNumber);
  };

  const changeNumberFlagHandler = (flag, currentNumber) => {
    changeEmailFlagHandler(false, currentNumber);
  };

  const onValidPasswordHandler = (currentPassword) => {
    setPassword((prevState) => {
      return currentPassword;
    });
  };

  const changePasswordFlagHandler = (flag) => {
    setValidPassword((prevState) => {
      return flag;
    });
    setPasswordLabel(
      "* Password should be of minimum 8 characters and maximum 40 characters, with uppercase,lowercase,numerics and a special character."
    );
  };

  const onNext = (event) => {
    if (email.length === 0) {
      setEmailTFResultLabel("*Email address is required.");
    }
    if (!props.socialLogin) {
      if (password.length === 0) {
        setPassword((prevState) => {
          return "";
        });
        setPasswordLabel("*Password is required.");
      }
    }
    if (!checkAPI.dataStatus.isSuccess && email.length !== 0) {
      validateBlur = true;
      onValidEmailHandler(email);
      changeEmailFlagHandler(Constants.validateEmail(email), email);
    }
    if (checkAPI.dataStatus.isSuccess && validPassword) {
      SignUp();
    }
  };

  const SignUp = () => {
    props.onDone({
      User: {
        username: email,
        usernametype: "email",
        password: password,
        socialLogin: "false",
        socialLoginVia: "Login",
      },
    });
    props.setOtpVerifiedSuccessfully(false);
  };

  const googleSignUp = (event) => {
    SignUpController.signIn(true, "Google", environment.loginAppUrl);
  };

  const appleSignUp = async (event) => {
    try {
      setAppleLoader(true);
      const data = await window.AppleID.auth.signIn();
      facebookSignInCheck(data.authorization.id_token, "Apple");
    } catch (error) {
      console.log(error);
      setAppleLoader(false);
    }
  };

  const facebookSignInCheck = (token, socialLoginType) => {
    var User = {
      id_token: token,
      socialLogin: "true",
      socialLoginVia: socialLoginType,
    };
    fetch(environment.myPlanLoginAppAPI + Constants.signInCheck, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        User: User,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.dataStatus && result.dataStatus.isSuccess) {
            if (
              Object.keys(result.payload).length &&
              result.payload.entry_method === "login"
            ) {
              setAppleLoader(false);
              Constants.remove_hash_from_url();
              props.login(
                {
                  emailAddress: result.payload.email,
                  id_token: token,
                },
                Constants.myPlanOauthLogin
              );
            } else if (
              Object.keys(result.payload).length &&
              result.payload.entry_method === "signup"
            ) {
              setAppleLoader(false);
              Constants.remove_hash_from_url();
              props.onDone({
                User: {
                  username: result.payload.email,
                  usernametype: "email",
                  socialLogin: "true",
                  socialLoginVia: socialLoginType,
                  id_token: token,
                },
              });
            }
          } else {
            setAppleLoader(false);
            Constants.remove_hash_from_url();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  return (
    <div className="App col-12 d-flex align-items-center myPlan">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-7 col-md-12 d-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column justify-content-between h-100 margin-interaction-card">
              <div className="mb-3">
                <Heading text="Sign up to manage your business planning easier"></Heading>
                <Description
                  className="d-block mb-4 description"
                  text="A simple, powerful solution for your business"
                />
                <FeatureCardContainer
                  data={[
                    {
                      heading: "Get to know your Business",
                      description:
                        "Run what if scenarios for various business opportunities and challenges",
                      slideImage: What_If_Scenario_Illustration,
                    },
                    {
                      heading: "Business Budgets made Quick & Easy",
                      description:
                        "Create budgets for your Business in minutes, no financial knowledge required whatsoever",
                      slideImage: Plan_Budgets_Illustration,
                    },
                    {
                      heading: "Predict your cashflow",
                      description:
                        "Foresee your business cashflow directly from myPlan",
                      slideImage: Predict_Cashflow_Illustration,
                    },
                  ]}
                />
              </div>
              {false && (
                <div className="padding-top">
                  <CustomLink
                    to=""
                    text="I Have A Referral Code !"
                  ></CustomLink>
                  <HighlightText
                    className="p1"
                    subClassName="bold-green-text"
                    text1="Congrats!!! You have an"
                    text2="off on premium Upgrade"
                    subText="Extra 10%"
                  ></HighlightText>
                </div>
              )}
              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 d-lg-flex d-block align-items-center bg-white blr-20">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myPlan_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div className="top-bottom-15-padding social-login-icon-container d-flex align-items-center justify-content-around">
                <div
                  className="google-icon-parent d-flex flex-wrap align-items-center cursor-pointer"
                  onClick={googleSignUp}
                >
                  {!googleLoader && (
                    <img
                      src="https://cdn.zetran.com/assets-mybooks/accounts-portal/GoogleIcon.png"
                      alt=""
                      className="side-logo"
                    ></img>
                  )}
                  {googleLoader && (
                    <div className="side-logo d-flex align-items-center justify-content-center">
                      <div
                        className="spinner-border purple"
                        role="status"
                      ></div>
                    </div>
                  )}
                  <div className="google-icon-label">Sign Up with Google</div>
                </div>

                {!appleLoader && (
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={appleSignUp}
                    className="side-logo apple"
                  >
                    <path
                      className="apple-logo"
                      d="M14.94 5.19C15.3181 4.75428 15.6063 4.24817 15.7882 3.70074C15.9701 3.1533 16.0421 2.57533 16 2C14.8394 2.09369 13.762 2.63956 13 3.52C12.6351 3.94198 12.3586 4.43288 12.1868 4.96364C12.015 5.49441 11.9515 6.05424 12 6.61C12.5661 6.61472 13.1258 6.4891 13.6356 6.24286C14.1454 5.99662 14.5917 5.63637 14.94 5.19ZM17.46 12.63C17.4667 11.8637 17.6685 11.1118 18.0465 10.4452C18.4244 9.77859 18.9659 9.21926 19.62 8.82C19.2072 8.22524 18.6615 7.73483 18.0262 7.38767C17.3909 7.04052 16.6835 6.84615 15.96 6.82C14.4 6.66 12.96 7.73 12.13 7.73C11.3 7.73 10.13 6.84 8.83 6.86C7.98013 6.888 7.15202 7.13578 6.42645 7.57919C5.70088 8.02259 5.10261 8.64648 4.69 9.39C2.93 12.45 4.24 17 6 19.47C6.8 20.68 7.8 22.05 9.12 22C10.44 21.95 10.87 21.18 12.4 21.18C13.93 21.18 14.4 22 15.7 21.97C17 21.94 17.92 20.73 18.76 19.52C19.355 18.6415 19.8199 17.6816 20.14 16.67C19.3475 16.332 18.6713 15.7693 18.195 15.0513C17.7188 14.3333 17.4632 13.4916 17.46 12.63Z"
                      fill="black"
                    />
                  </svg>
                )}
                {appleLoader && (
                  <div className="side-logo d-flex align-items-center justify-content-center">
                    <div className="spinner-border purple" role="status"></div>
                  </div>
                )}
              </div>
              <div className="bottom-15-padding">
                <label className="label">Enter your Mail ID</label>
                <EmailTextField
                  className={`${email !== "" ? "value-entered" : ""}`}
                  value={email}
                  showLoader={showEmailLoader}
                  onChange={onEmailTFChange}
                  onValidEmail={onValidEmailHandler}
                  changeEmailFlag={changeEmailFlagHandler}
                  onValidNumber={onValidNumberHandler}
                  changeNumberFlag={changeNumberFlagHandler}
                  isSignUp={true}
                  dontShowNumberLabel={true}
                  hasPlaceHolder={true}
                  placeholder="Email ID"
                ></EmailTextField>
                {emailTFResultLabel.length !== 0 && (
                  <label
                    className={`result-label ${
                      emailTFResultLabelFlag ? "valid-label" : ""
                    }`}
                  >
                    {emailTFResultLabel}
                  </label>
                )}
              </div>
              <div className="bottom-15-padding">
                <label className="label">Set up your Password</label>
                <PasswordTextField
                  className={`${password !== "" ? "value-entered" : ""}`}
                  value={password}
                  onValid={onValidPasswordHandler}
                  changeFlag={changePasswordFlagHandler}
                  onBlur={() => {}}
                  isSignUp={true}
                ></PasswordTextField>
                {(password !== "" ||
                  passwordLabel === "*Password is required.") &&
                  !validPassword && (
                    <label className="result-label">{passwordLabel}</label>
                  )}
                {validPassword && (
                  <label className="account-safe-label">
                    <i className="fas fa-check-circle success-tick"></i>Your
                    password is secure
                  </label>
                )}
              </div>
              <div className="my-3">
                <div className="terms-and-policy text-align-left">
                  By signing up, you are agreeing to our{" "}
                  <a
                    href="https://www.zetran.com/mybooks/securitypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blue"
                  >
                    terms of services
                  </a>{" "}
                  &{" "}
                  <a
                    href="https://www.zetran.com/privacypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blue"
                  >
                    privacy policy
                  </a>
                </div>
              </div>
              <div className="bottom-15-padding">
                <button
                  className="button d-flex flex-wrap align-items-center justify-content-center"
                  onClick={onNext}
                >
                  {!props.showLoader && (
                    <>
                      <div className="mr-2">Get Started</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Outline"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path
                          fill="#fff"
                          d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                        />
                      </svg>
                    </>
                  )}
                  {props.showLoader && (
                    <div className="spinner-border" role="status"></div>
                  )}
                </button>
              </div>

              <div className="d-flex flex-wrap align-items-center justify-content-center my-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Filled"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                >
                  <path
                    fill="#27AE60"
                    d="M18.581,2.14,12.316.051a1,1,0,0,0-.632,0L5.419,2.14A4.993,4.993,0,0,0,2,6.883V12c0,7.563,9.2,11.74,9.594,11.914a1,1,0,0,0,.812,0C12.8,23.74,22,19.563,22,12V6.883A4.993,4.993,0,0,0,18.581,2.14ZM16.718,9.717l-4.272,4.272a1.873,1.873,0,0,1-1.335.553h-.033a1.872,1.872,0,0,1-1.345-.6l-2.306-2.4A1,1,0,1,1,8.868,10.16L11.112,12.5,15.3,8.3a1,1,0,0,1,1.414,1.414Z"
                  />
                </svg>
                <div className="font-12-400 d-inline grey mx-2">
                  Safe & Secure
                </div>
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-center">
                <div className="font-12-400 d-inline">
                  Already using myPlan ?
                </div>
                <CustomLink
                  to="/myPlan/login"
                  text="Sign in"
                  hasOnClick={true}
                  onClick={() => {
                    props.clearData();
                  }}
                ></CustomLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SignUpMyPlan;
